import React from 'react';
import PropTypes from 'prop-types';

import {
  Text,
} from '../../components';

export const Commissions = ({
  classes
}) => {
  return (
    <div 
      className={classes.page}
    >
      <Text>Comisiones</Text>
    </div>
  );
};

export default Commissions;

Commissions.propTypes = {
  classes: PropTypes.object
};

Commissions.defaultProps = {
  classes: {}
};
